import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q1/2022body_building/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const getVoteList = (page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search,
    },
  });
};

const getBackList = (page: number) => {
  return http.get(`${urlPrefix}vote-list-back`, {
    params: {
      page,
    },
  });
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};
const detailBack = (id: any) => {
  return http.get(`${urlPrefix}detail-back`, {
    params: {
      id,
    },
  });
};

const getUser = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}user-list`, qsData);
};

const ifSave = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}if-save`, qsData);
};
export {
  getNews,
  getBaseInfo,
  getVoteList,
  getDetail,
  getBackList,
  save,
  detailBack,
  getUser,
  ifSave,
};
